import { useEffect, useRef } from "react";

const useTimeout = (
  callback: () => void,
  delay: number,
  enabled = true,
  dependencies?: unknown[],
) => {
  const timeout = useRef<number | undefined>();
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    clearTimeout(timeout.current);
    if (enabled) {
      timeout.current = window.setTimeout(() => savedCallback.current(), delay);
    }
    return () => clearTimeout(timeout.current);
  }, [enabled, ...(dependencies || [])]);

  return {
    clear: () => clearTimeout(timeout.current),
  };
};

export default useTimeout;
